<template>
  <div class="appointment">
    <v-card class="rounded-0 pa-5" v-if="loading" flat>
      <v-progress-linear indeterminate />
    </v-card>

    <v-card class="rounded-0 pa-5" v-if="!loading && appointment" flat>
      <!-- header -->
      <v-row no-gutters>
        <v-col class="col-11">
          <p class="mb-0">
            <span class="text-h5">{{ appointment.type }} </span>
            <v-chip class="mb-2" small>{{ appointment.status }}</v-chip>
          </p>
          <p class="text-subtitle-2">
            {{ $t('dashboard.cardAppointment.scheduling') }}:
            {{ appointment.code }} &bull;
            {{ $t('dashboard.cardAppointment.realtyCode') }}:
            {{ appointment.realties[0].code }}
          </p>
        </v-col>
        <v-col class="col-1 text-right" v-if="isModal">
          <v-icon
            aria-label="Close"
            @click="$parent.$parent.$parent.closeApointment()"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>
      <!-- /header -->

      <v-divider />

      <v-row no-gutters class="pt-3 pl-0 pr-0 pb-3">
        <v-col class="col-1">
          <v-icon class="grey--text text--lighten-1">
            mdi-account-tie
          </v-icon>
        </v-col>
        <v-col class="col-11 pt-1">
          <strong>{{ appointment.real_estate.name }}</strong>
        </v-col>
      </v-row>

      <v-row
        no-gutters
        v-if="appointment.host"
        class="pt-0 pl-0 pr-0 pb-3 mt-0"
      >
        <v-col class="col-1"></v-col>
        <v-col class="col-8">
          <p class="text-subtitle-2 mb-0">{{ appointment.host.name }}</p>
          <p class="text--caption mb-1">{{ appointment.host.username }}</p>
          <p class="text--caption mb-0">{{ appointment.host.phone }}</p>
        </v-col>
        <v-col class="col-3">
          <!-- rating here -->
        </v-col>
      </v-row>

      <v-divider />

      <v-card-text class="black--text pa-0">
        <v-row class="pt-5 pl-0 pr-0 pb-0">
          <v-col class="col-1">
            <v-icon class="grey--text text--lighten-1">
              mdi-comment-alert-outline
            </v-icon>
          </v-col>
          <v-col class="col-9">
            <strong>
              {{ $t('dashboard.cardAppointment.observation') }}:
            </strong>
            <br />
            {{ appointment.observations ? appointment.observations : '---' }}
          </v-col>
        </v-row>

        <v-row class="pt-2 pl-0 pr-0 pb-0">
          <v-col class="col-1">
            <v-icon class="grey--text text--lighten-1">
              mdi-calendar
            </v-icon>
          </v-col>
          <v-col class="col-10">
            <strong> {{ $t('dashboard.cardAppointment.date') }}: </strong>
            <br />
            {{ appointment.date ? appointment.date : '---' }}
          </v-col>
        </v-row>

        <v-row class="pt-2 pl-0 pr-0 pb-0">
          <v-col class="col-1">
            <v-icon class="grey--text text--lighten-1">
              mdi-map-marker-outline
            </v-icon>
          </v-col>
          <v-col class="col-10">
            <strong> {{ $t('dashboard.cardAppointment.address') }}: </strong>
            <br />
            {{
              appointment.meeting_location_description
                ? appointment.meeting_location_description
                : '---'
            }}
          </v-col>
        </v-row>

        <v-row class="pt-2 pl-0 pr-0 pb-0">
          <v-col class="col-1">
            <v-icon class="grey--text text--lighten-1">
              mdi-ruler-square
            </v-icon>
          </v-col>
          <v-col class="col-10">
            <v-row>
              <v-col class="col-6">
                <strong>
                  {{ $t('dashboard.cardAppointment.totalArea') }}:
                </strong>
                <br />
                {{
                  appointment.realties[0].square_meters
                    ? `${appointment.realties[0].square_meters} m2`
                    : '---'
                }}
              </v-col>
              <v-col class="col-6">
                <strong>
                  {{ $t('dashboard.cardAppointment.privateArea') }}:
                </strong>
                <br />
                {{
                  appointment.realties[0].private_area_meters
                    ? `${appointment.realties[0].private_area_meters} m2`
                    : '---'
                }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AppointmentDetails',

  props: {
    loading: Boolean,
    appointment: Object,
    isModal: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
